import styles from './disinfectVideo.module.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
import { useRef } from 'react';
import DOMPurify from 'dompurify';
import { useState } from 'react';
gsap.registerPlugin(ScrollTrigger);
const DisinfectVideo = ({ textData }) => {
  const ctnRef = useRef(null);
  const maskRef = useRef(null);
  const canvasRef = useRef(null);
  const text1Ref = useRef(null);
  const text2Ref = useRef(null);
  const text3Ref = useRef(null);
  const text4HRef = useRef(null);
  const text4PRef = useRef(null);

  const disinfectAlertButtonBoxRef = useRef(null);
  const [openAlert, setOpenAlert] = useState(false);

  const disinfectAnimation = () => {
    const currentFrame = (index) =>
      `https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-video-disinfect/zhiyunlife-ozone-video-disinfect-${(
        index + 1
      )
        .toString()
        .padStart(5, '0')}.jpg`;

    const canvas = canvasRef.current;
    // console.log(canvas);
    const context = canvas.getContext('2d');
    canvas.width = 1920;
    canvas.height = 1080;
    const frameCount = 191;
    const images = [];
    const xdbFrames = {
      frame: 0,
    };

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      // console.log(img.src);
      images.push(img);
    }

    images[xdbFrames.frame].onload = render;

    function render() {
      // console.log(xdbFrames.frame);
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(images[xdbFrames.frame], 0, 0);
    }

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: 'top top',
        pin: true,
        end: '300%',
        pinSpacing: true,
        scrub: 1,
        
      },
    });

    tl.to(xdbFrames, {
      frame: 190,
      snap: 'frame',
      onUpdate: render,
      duration: 20,
    });

    tl.to(
      text1Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 3,
      },
      0,
    );

    tl.to(
      text1Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      0,
    );

    tl.to(
      text1Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      2,
    );

    tl.to(
      text2Ref.current,
      {
        y: 'var(--effect-offset-y)4',
        duration: 3,
      },
      3,
    );

    tl.to(
      text2Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      3,
    );

    tl.to(
      text2Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      5,
    );

    tl.to(
      text3Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      6,
    );

    tl.to(
      text3Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      6,
    );

    tl.to(
      text3Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      9,
    );

    tl.to(
      text4HRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      10,
    );

    tl.to(
      text4HRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      10,
    );

    tl.to(
      text4PRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      11,
    );

    tl.to(
      text4PRef.current,
      {
        opacity: 1,
        duration: 1,
      },
      11,
    );

    tl.to(
      disinfectAlertButtonBoxRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      12,
    );

    tl.to(
      disinfectAlertButtonBoxRef.current,
      {
        opacity: 1,
        duration: 1,
      },
      12,
    );

    // tl.to(
    //   text4Ref.current,
    //   {
    //     opacity: 0,
    //     duration: 1,
    //   },
    //   18.5,
    // );

    // tl.to(
    //   text5Ref.current,
    //   {
    //     y: 'var(--effect-offset-y)',
    //     duration: 4.5,
    //   },
    //   19.5,
    // );

    // tl.to(
    //   text5Ref.current,
    //   {
    //     opacity: 1,
    //     duration: 0.5,
    //   },
    //   19.5,
    // );

    // tl.to(
    //   text5Ref.current,
    //   {
    //     opacity: 0,
    //     duration: 1,
    //   },
    //   23,
    // );

    // tl.to(
    //   text6Ref.current,
    //   {
    //     y: 'var(--effect-offset-y)',
    //     duration: 4.5,
    //   },
    //   24,
    // );

    // tl.to(
    //   text6Ref.current,
    //   {
    //     opacity: 1,
    //     duration: 0.5,
    //   },
    //   24,
    // );

    // tl.to(
    //   text6Ref.current,
    //   {
    //     opacity: 0,
    //     duration: 0.5,
    //   },
    //   28,
    // );

    // tl.to(
    //   text7HRef.current,
    //   {
    //     y: 'var(--effect-offset-y)',
    //     duration: 4.5,
    //   },
    //   28.5,
    // );

    // tl.to(
    //   text7HRef.current,
    //   {
    //     opacity: 1,
    //     duration: 0.5,
    //   },
    //   28.5,
    // );

    // tl.to(
    //   text7HRef.current,
    //   {
    //     opacity: 0,
    //     duration: 1,
    //   },
    //   32,
    // );

    // tl.to(
    //   text7PRef.current,
    //   {
    //     y: 'var(--effect-offset-y)',
    //     duration: 4.5,
    //   },
    //   29,
    // );

    // tl.to(
    //   text7PRef.current,
    //   {
    //     opacity: 1,
    //     duration: 0.5,
    //   },
    //   29,
    // );

    // tl.to(
    //   text7PRef.current,
    //   {
    //     opacity: 0,
    //     duration: 1,
    //   },
    //   32,
    // );

    // tl.to(
    //   text8HRef.current,
    //   {
    //     y: 'var(--effect-offset-y)',
    //     duration: 4.5,
    //   },
    //   33,
    // );

    // tl.to(
    //   text8HRef.current,
    //   {
    //     opacity: 1,
    //     duration: 0.5,
    //   },
    //   33,
    // );

    // tl.to(
    //   text8HRef.current,
    //   {
    //     opacity: 0,
    //     duration: 0.5,
    //   },
    //   37,
    // );

    // tl.to(
    //   text8PRef.current,
    //   {
    //     y: 'var(--effect-offset-y)',
    //     duration: 4.5,
    //   },
    //   33.5,
    // );

    // tl.to(
    //   text8PRef.current,
    //   {
    //     opacity: 1,
    //     duration: 0.5,
    //   },
    //   33.5,
    // );

    // tl.to(
    //   text8PRef.current,
    //   {
    //     opacity: 0,
    //     duration: 0.5,
    //   },
    //   37,
    // );
  };
  useEffect(() => {
    disinfectAnimation();
  }, []);

  useEffect(() => {
    if (openAlert) {
      document.querySelector('body').classList.add('alert-open');
    } else if (!openAlert) {
      document.querySelector('body').classList.remove('alert-open');
    }
  }, [openAlert]);
  // useEffect(() => {
  //   let tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: ctnRef.current,
  //       start: 'top top',
  //       end: '+=300%',
  //       pin: true,
  //       pinSpacing: true,
  //       scrub: 1,
  //     },
  //   });

  //   tl.to(text1HRef.current, {
  //     y: -100,
  //     duration: 4,
  //   });

  //   tl.to(
  //     text1HRef.current,
  //     {
  //       opacity: 1,
  //       duration: 0.5,
  //     },
  //     0,
  //   );

  //   tl.to(
  //     text1PRef.current,
  //     {
  //       y: -100,
  //       duration: 4,
  //     },
  //     0.5,
  //   );

  //   tl.to(
  //     text1PRef.current,
  //     {
  //       opacity: 1,
  //       duration: 0.5,
  //     },
  //     0.5,
  //   );

  //   tl.to(
  //     text1HRef.current,
  //     {
  //       opacity: 0,
  //       duration: 1,
  //     },
  //     3,
  //   );

  //   tl.to(
  //     text1PRef.current,
  //     {
  //       opacity: 0,
  //       duration: 1,
  //     },
  //     3,
  //   );

  //   tl.to(
  //     text2HRef.current,
  //     {
  //       y: -100,
  //       duration: 4,
  //     },
  //     4,
  //   );

  //   tl.to(
  //     text2HRef.current,
  //     {
  //       opacity: 1,
  //       duration: 0.5,
  //     },
  //     4,
  //   );

  //   tl.to(
  //     text2PRef.current,
  //     {
  //       y: -100,
  //       duration: 4,
  //     },
  //     4.5,
  //   );

  //   tl.to(
  //     text2PRef.current,
  //     {
  //       opacity: 1,
  //       duration: 0.5,
  //     },
  //     4.5,
  //   );

  //   tl.to(
  //     text2HRef.current,
  //     {
  //       opacity: 0,
  //       duration: 1,
  //     },
  //     7,
  //   );

  //   tl.to(
  //     text2PRef.current,
  //     {
  //       opacity: 0,
  //       duration: 1,
  //     },
  //     7,
  //   );

  //   tl.to(
  //     maskRef.current,
  //     {
  //       opacity: 0,
  //       duration: 1,
  //     },
  //     7,
  //   );

  //   tl.to(maskRef.current, {
  //     opacity: 0,
  //     duration: 4,
  //   });
  // }, []);
  return (
    <div
      className={styles.ctn}
      ref={ctnRef}
      onClick={() => {
        setOpenAlert(false);
      }}
    >
      <canvas ref={canvasRef}></canvas>
      <h3
        className={`${styles.text1} ${styles.disinfectText}`}
        ref={text1Ref}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text5']),
        }}
      ></h3>

      <h3
        className={`${styles.text2} ${styles.disinfectText}`}
        ref={text2Ref}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text6']),
        }}
      ></h3>

      <div className={`${styles.text3} ${styles.disinfectText}`} ref={text3Ref}>
        {/* <h3
          className={styles.text3H}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text7']),
          }}
        ></h3> */}

        <h3
          className={`${styles.text3P}`}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text7']),
          }}
        ></h3>
      </div>

      <div className={`${styles.text4Box} ${styles.disinfectText}`}>
        <h3
          className={`${styles.text4H}`}
          ref={text4HRef}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text8']),
          }}
        ></h3>
        <h6
          className={`${styles.text4P}`}
          ref={text4PRef}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text9']),
          }}
        ></h6>
        <div
          className={styles.disinfectAlertButtonBox}
          ref={disinfectAlertButtonBoxRef}
          onClick={(e) => {
            e.stopPropagation();
            setOpenAlert(!openAlert);
          }}
        >
          <div className={`${styles.alert} ${openAlert ? 'active' : ''}`}>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text11']),
              }}
            ></h3>
            {/* <video
              autoPlay
              loop
              playsInline
              muted
              preload="true"
              src="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-disinfect.mp4"
            ></video> */}
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text12']),
              }}
            ></h5>
          </div>
          <div
            className={`${styles.disinfectAlertButton} ${
              openAlert ? 'active' : ''
            }`}
          >
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text10']),
              }}
            ></h5>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`${styles.modalButtonIcon} ${
                openAlert ? 'modal-open' : ''
              }`}
            >
              <path
                d="M16.0752 6.93368C16.7173 6.56399 17.4351 7.28177 17.0654 7.92388L15.2399 11.0946C14.9176 11.6545 14.9176 12.3437 15.2399 12.9036L17.0654 16.0743C17.4351 16.7164 16.7173 17.4342 16.0752 17.0645L12.9045 15.239C12.3446 14.9167 11.6554 14.9167 11.0955 15.239L7.92478 17.0645C7.28266 17.4342 6.56489 16.7164 6.93458 16.0743L8.76009 12.9036C9.08245 12.3437 9.08245 11.6545 8.76009 11.0946L6.93458 7.92388C6.56489 7.28177 7.28266 6.564 7.92478 6.93368L11.0955 8.75919C11.6554 9.08155 12.3446 9.08155 12.9045 8.75919L16.0752 6.93368Z"
                className={styles.modalButtonPath1}
              />
              <path
                d="M14.3287 9.10608C14.6956 8.89483 15.1058 9.30498 14.8945 9.67191L13.8514 11.4838C13.6672 11.8037 13.6672 12.1975 13.8514 12.5175L14.8945 14.3293C15.1058 14.6962 14.6956 15.1064 14.3287 14.8951L12.5168 13.852C12.1969 13.6678 11.8031 13.6678 11.4832 13.852L9.6713 14.8951C9.30438 15.1064 8.89422 14.6962 9.10547 14.3293L10.1486 12.5175C10.3328 12.1975 10.3328 11.8037 10.1486 11.4838L9.10547 9.67191C8.89422 9.30498 9.30438 8.89483 9.6713 9.10608L11.4832 10.1492C11.8031 10.3334 12.1969 10.3334 12.5168 10.1492L14.3287 9.10608Z"
                className={styles.modalButtonPath2}
              />
            </svg>
          </div>
        </div>
      </div>

      <div
        className={`${styles.mask} ${openAlert ? 'active' : ''}`}
        ref={maskRef}
      ></div>
    </div>
  );
};
export default DisinfectVideo;
